import { createApi } from '@reduxjs/toolkit/query/react'
import customFetchBase from '../services/CustomFetchBase'

/**
 * API slice for handling license product-related operations.
 */
export const getLicenseProductsApi = createApi({
    reducerPath: 'getLicenseProductsApi',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        /**
         * Mutation to fetch a list of license products based on flow and license type.
         * @param {Object} params - The parameters for the API request.
         * @param {string} params.flow - The flow type (e.g., purchase, renewal).
         * @param {string} params.licenseType - The type of license (e.g., standard, enterprise).
         * @returns {Promise<any>} The list of available license products.
         */
        getLicenseProductsListApi: builder.mutation({
            query: ({ flow, licenseType }) => ({
                url: `/getLicenseProducts?flow=${flow}&licenseType=${licenseType}`,
                method: 'GET'
            })
        }),

        /**
         * Mutation to add a purchased license.
         * @param {Object} body - The request body containing purchase details.
         * @returns {Promise<any>} The response from the server after adding the license.
         */
        addPurchasesLicenseApi: builder.mutation({
            query: (body) => ({
                url: 'addPurchasesLicense',
                method: 'POST',
                body
            })
        }),

        /**
         * Mutation to fetch a list of training courses based on flow and license type.
         * @param {Object} params - The parameters for the API request.
         * @param {string} params.flow - The flow type (e.g., purchase, renewal).
         * @param {string} params.licenseType - The type of license (e.g., standard, enterprise).
         * @returns {Promise<any>} The list of available license products.
         */
        getTriningCoursesListApi: builder.mutation({
            query: ({ flow, licenseType }) => ({
                url: `/getLicenseProducts?type=${licenseType}&flow=${flow}`,
                method: 'GET'
            })
        }),

        getEvaluationCoursesListApi: builder.mutation({
            query: ({ flow, licenseType }) => ({
                url: `/getLicenseProducts?type=${licenseType}&flow=${flow}`,
                method: 'GET'
            })
        }),
    })
})

/**
 * Auto-generated hooks for the defined mutations.
 */
export const { useGetLicenseProductsListApiMutation, useAddPurchasesLicenseApiMutation, useGetTriningCoursesListApiMutation, useGetEvaluationCoursesListApiMutation } = getLicenseProductsApi
